import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import { Link, useLocation, useParams } from "react-router-dom";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { getNoticeSlide, INoticeSlideProps } from "api/commonApi";
import { isThroughMainState } from "recoil/contentsAtom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faDotCircle } from "@fortawesome/free-solid-svg-icons";
import { langCodeState } from "recoil/commonUiAtom";

function NoticeSlide() {
  const { service_code } = useParams();
  const langCode = useRecoilValue(langCodeState);
  const location = useLocation();
  const { isLoading, data } = useQuery<INoticeSlideProps>(
    ["slide"],
    () => getNoticeSlide(service_code || "", langCode),
    {
      enabled: !(location.pathname.split("/")[1] === "profile")
    }
  );
  const ref = useRef<HTMLDivElement>(null);
  const [slideIndex, setSlideIndex] = useState(1);
  const setIsThroughMain = useSetRecoilState(isThroughMainState);
  const { t } = useTranslation();
  const [addDataClassName, setAddDataClassName] = useState("");

  useEffect(() => {
    if (data?.result === 1) {
      setAddDataClassName("");
      const interval = setInterval(() => {
        if (!ref.current) {
          return;
        }

        ref.current.style.transition = `all 0.5s ease-in-out`;
        ref.current.style.transform = `translateY(-${slideIndex}00%)`;

        if (slideIndex === data.data.length + 1) {
          ref.current.style.transition = `0s`;
          ref.current.style.transform = `translateY(0)`;
          setSlideIndex(1);
        } else {
          setSlideIndex(slideIndex + 1);
        }
      }, 2000);

      return () => {
        clearInterval(interval);
      };
    } else {
      setAddDataClassName("no-data");
    }
  }, [data, slideIndex]);

  const checkPostState = () => {
    setIsThroughMain(true);
  };

  const pageNum = () => {
    if (data?.result === 1) {
      const totalNum = data?.data.length === undefined ? 0 : data?.data.length;
      const currentNum =
        slideIndex > totalNum ? slideIndex - totalNum : slideIndex;
      return `${currentNum} / ${totalNum}`;
    }
  };

  return (
    <div className={`notice ${addDataClassName}`}>
      {!isLoading ? (
        data?.result === 1 ? (
          <>
            <div className="left">
              <div className="icon speaker" />
              {/* 3개의 공지 */}
              <div className="lists " ref={ref}>
                {data?.data.map((i) => (
                  <Link
                    to={`${i.section}/${i.idx}`}
                    key={i.idx}
                    onClick={checkPostState}
                  >
                    <div className="list ellipsis">{`[${t(i.lang_code)
                      .trim()
                      .slice(0, 7)}] ${i.title}`}</div>
                  </Link>
                ))}

                {/* 첫번째 슬라이드만 다시 보여줘서 공백 만들지 않기 */}
                <Link
                  to={`${data?.data[0].section}/${data?.data[0].idx}`}
                  onClick={checkPostState}
                >
                  <div className="list ellipsis">{`[${t(data?.data[0].lang_code)
                    .trim()
                    .slice(0, 7)}] ${data?.data[0].title}`}</div>
                </Link>
              </div>
            </div>

            {/* 공지의 페이지 */}
            <ul className="right">{pageNum()}</ul>
          </>
        ) : (
          // 공지 데이터 없을 시: 타이틀로 대체
          <div className="toggle-title">
            {/* <span className="fas fa-dot-circle" />  */}
            <FontAwesomeIcon
              icon={faDotCircle as IconProp}
              className="faDotCircle"
            />
            {t("View_Type")}
          </div>
        )
      ) : null}
    </div>
  );
}

export default NoticeSlide;
